import React, { useState, useEffect, Fragment, useRef } from "react";
import ReactDom, { unmountComponentAtNode } from "react-dom";
import Form from "react-bootstrap/Form";
import { utils, ResponseCode, VagaroAPIURL } from "../../utils/Utils";
import Leftpanel from "../../Layout/Sidebar/LeftPanel";
import NoRights from "../Common/NoRights";
import { AsyncAjaxGet, AsyncAjaxPost } from "../Common/AsyncAjaxService";
import useGenerateToken from "components/Hook/useGenerateToken";
import useSession from "components/Hook/useSession";
import './Multilocation.scss'
import MultiSelectBusiness from "components/Controls/MultiSelectBusiness";
import ChangeNickName from "./ChangeNickName";
import { UpdateLocationCount } from 'components/Slice/Business'
import VGPopUp from "components/Controls/VGPopUp";
import $ from 'jquery';
import { SaveMultilocation } from "components/WebDesigner/Menus/SaveMultilocation";
import store from '../../app/store'
import Toast from "components/WebDesigner/Toast";
import { GenericConfirmation } from "components/WebDesigner/ConfirmationPopups";

const Multilocation = (props) => {

    //Comment for every state meaning.
    const { BusinessID, ReactBusinessId, UserID, VagaroURL, CurrencySymbol, IsNewCustomWebSite, IsModifyAllowed, CountryID } = store.getState().Business;

    const dispatch = props.dispatch;



    const [planAmount, setPlanAmount] = useState(0); //Set Plan Amount Based on Location Selection
    const [select2Location, setSelect2Location] = useState([]); //Location List Select2 Format Group Wise

    const location = useRef([]); // Location List in Grid
    const isPromoCodeBusiness = useRef(false); // Location List in Grid

    const selectedLocation = useRef([]); //Default Selection dropdown variable set based on loading time
    const locationPlan = useRef([]); //Price Lable as per changes as per location selection

    const [loadStencil, setLoadStencil] = useState(false); // Page loading time stancil load
    const [saveStencil, setSaveStencil] = useState(false); // Page loading time stancil load

    const [isRefresh, setIsRefresh] = useState(false);
    const [locationCount, setLocationCount] = useState(0);

    const compareString = useRef("");
    const aliasTypeCompare = useRef("");

    const defaultBusinessID = useRef("");

    useEffect(() => {
        utils.SetPageTitle("Multi-Location");
        CheckSession();
    }, [BusinessID]);


    const UpdateLockState = () => {

        if (props.designer) {

            let alias = (location.current && location.current.length > 0) ? location.current[0].alias : "none";

            if (compareString.current != selectedLocation.current.toString() || aliasTypeCompare.current != alias) {
                props.designer.panelMenuLocked = true;
            }
            else {
                props.designer.panelMenuLocked = false;
            }
        }
    }


    useEffect(() => {

        return () => {

            if (props.designer) {
                props.designer.panelMenuLocked = false;
            }

        }

    }, []);

    // Check session for component loadin time
    const CheckSession = async () => {
        setLoadStencil(true);
        return await useSession(dispatch, BusinessID, UserID, (data) => {
            setLoadStencil(false);
            if (data == true) {
                GetMultilocationPlan(props.Mode);
                GetMultilocation(false);
            }
        });
    }

    // Get location API based on
    const GetMultilocation = async (issaveStencil) => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token)) {
            if (props.Mode == 2) {
                props.onLoading(true);
            }
            else {
                if (issaveStencil) {
                    setSaveStencil(true);
                }
                else {
                    setLoadStencil(true);
                }
            }

            await AsyncAjaxGet(
                VagaroAPIURL.GetMultilocation,
                access_token,
                GetMultilocation_Success,
                GetMultilocation_Fail,
                BusinessID,
                UserID
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };


    //Get multilocation onsuccess methods.
    const GetMultilocation_Success = (data) => {
        try {
            if (
                data != null &&
                data.data != null &&
                data.data.responseCode == ResponseCode.Success
            ) {
                let filterChild = [];
                if (data != null && data.data != null && data.data.data != null && data.data.data != null) {
                    var resultdata = data.data.data.merchantMapping;

                    resultdata.map((data, index) => {
                        data.isDefaultSelected = data.isSelected
                    });

                    location.current = resultdata;
                    isPromoCodeBusiness.current = data.data.data.isPromoCodeBusiness

                    if (location.current && location.current.length > 0) {
                        aliasTypeCompare.current = location.current[0].alias;

                    }
                    //Start Dropdown Binding Format
                    var allResult = location.current;
                    let allStateNames = [];
                    let allStateNameString = [];
                    for (let index = 0; index < allResult.length; index++) {
                        const element = allResult[index];
                        if (utils.Validate(element.stateName)) {
                            if (!allStateNameString.includes(element.stateName)) {
                                allStateNameString.push(element.stateName);
                                allStateNames.push({ stateName: element.stateName });
                            }
                        }
                    }

                    var filterselected = allResult.filter(
                        (col) => col.isSelected === true
                    );

                    filterselected.map((d, j) => {
                        filterChild.push(d.merchantId)
                    });
                    selectedLocation.current = filterChild;
                    stateName = "";
                    stateIndex = 0;

                        let arrselect2Location = [];

                        if (isPromoCodeBusiness.current) {

                            allStateNames.map((d, i) => {
                                var statename = d.stateName;

                                var filter = resultdata.filter(
                                    (col) => {
                                        if(col.isDefault){
                                            defaultBusinessID.current = col.merchantId;
                                        }
                                        return col.stateName === statename}
                                );

                                var parentfilterselected = resultdata.filter(
                                    (col) => col.stateName === statename && col.isSelected === true
                                );

                                var snameswithremovecharacter = d.stateName.replace(/[!@#$%^&*()+=/~<>]/g, "-").replace(/[ ]/g, "-");
                                arrselect2Location.push({ groupName: true, isParent: true, label: d.stateName, value: "parent" + i.toString(), parentId: snameswithremovecharacter, isSelected: parentfilterselected.length > 0 ? true : false, isDefault: false });
                                filter.map((d, j) => {
                                    var data = filterselected.filter(
                                        (col) => col.merchantId === d.merchantId
                                    );
                                    arrselect2Location.push({ groupName: false, isParent: false, label: d.businessName + (utils.Validate(d.nickName) ? ' (' + d.nickName + ')' : ""), value: d.merchantId, parentId: snameswithremovecharacter, isSelected: (data.length > 0 || d.isDefault == true ? true : false), isDefault: (d.isDefault ? true : false) });
                                });
                            })
                        }
                        else {
                            resultdata.map((d, i) => {
                                if (utils.Validate(d.groupName)) {
                                    var gnameswithremovecharacter = d.groupName.replace(/[!@#$%^&*()+=/~<>]/g, "-").replace(/[ ]/g, "-");

                                    if (d.groupName == d.businessName) {
                                        var parentfilterselected = resultdata.filter(
                                            (col) => col.groupName === d.groupName && col.isSelected === true
                                        );
                                        arrselect2Location.push({ groupName: true, isParent: true, label: d.groupName, value: "parent" + i.toString(), parentId: gnameswithremovecharacter, isSelected: parentfilterselected.length > 0 ? true : false, isDefault: false });
                                    }
                                    else {
                                        var data = filterselected.filter(
                                            (col) => col.merchantId === d.merchantId
                                        );
                                        arrselect2Location.push({ groupName: false, isParent: false, label: d.businessName + (utils.Validate(d.nickName) ? ' (' + d.nickName + ')' : ""), value: d.merchantId, parentId: gnameswithremovecharacter, isSelected: (data.length > 0 || d.isDefault == true ? true : false), isDefault: (d.isDefault ? true : false) });
                                    }
                                }
                                else {
                                    var data = filterselected.filter(
                                        (col) => col.merchantId === d.merchantId
                                    );
                                    arrselect2Location.push({ groupName: false, isParent: true, label: d.businessName + (utils.Validate(d.nickName) ? ' (' + d.nickName + ')' : ""), value: d.merchantId, parentId: "blank", isSelected: (data.length > 0 || d.isDefault == true ? true : false), isDefault: (d.isDefault ? true : false) });
                                }

                                if(props.Mode == 2&&d.isDefault){
                                    defaultBusinessID.current = d.merchantId
                                }


                            })
                        }

                        if(props.Mode == 2 && defaultBusinessID.current == ""){
                            defaultBusinessID.current = BusinessID;
                        }

                        setSelect2Location(arrselect2Location);
                        if(props.Mode == 2){
                            MultiLocationSelect(arrselect2Location.toString())
                        }



                    compareString.current = selectedLocation.current.toString();
                    setIsRefresh(!isRefresh);
                }
            }
            setLoadStencil(false);
            setSaveStencil(false);
            if (props.Mode == 2) {
                props.onLoading(false);
            }
        } catch (error) {
            GetMultilocation_Fail();
        }
    }

    //Get multilocation onfail methods.
    const GetMultilocation_Fail = () => {
        setLoadStencil(false);
        setSaveStencil(false);
        if (props.Mode == 2) {
            props.onLoading(false);
        }
        utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }


    //Get multilocation plan data based on business or general configuration.
    const GetMultilocationPlan = async () => {
        const access_token = await useGenerateToken(dispatch);
        if (utils.Validate(access_token)) {
            setLoadStencil(true);
            await AsyncAjaxGet(
                VagaroAPIURL.GetMultilocationPlan,
                access_token,
                GetMultilocationPlan_Success,
                GetMultilocationPlan_Fail,
                BusinessID,
                UserID
            );
        }
        else {
            utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
        }
    };

    //Get multilocation plan success methods data based on business or general configuration.
    const GetMultilocationPlan_Success = (data) => {
        try {
            if (
                data != null &&
                data.data != null &&
                data.data.responseCode == ResponseCode.Success
            ) {
                if (data != null && data.data != null && data.data.data != null && data.data.data != null) {
                    locationPlan.current = data.data.data;
                }
                else {
                    locationPlan.current = []
                }
            }
            else {
                locationPlan.current = []
            }
            setLoadStencil(false);
        } catch (error) {
            GetMultilocationPlan_Fail();
        }
    }


    //Get multilocation plan failed methods data based on business or general configuration.
    const GetMultilocationPlan_Fail = () => {
        setLoadStencil(false);
        locationPlan.current = []
        utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }

    //multilocation dropdown click event
    const MultiLocationSelect = (merchantID) => {
        if (location.current.length > 0) {
            location.current.map((d, i) => {
                if (d.isDefault == false) {
                    d.isSelected = false;
                }
            });
        }

        var splitArrMerchant = merchantID.split(',');
        if (splitArrMerchant.length > 0) {
            let filterChild = [];
            splitArrMerchant.map((merchant, j) => {
                if (merchant.trim() != "" && merchant.trim() != "-1") {
                    filterChild.push(merchant);
                    if (location.current.length > 0) {
                        var Filterlocation = location.current.filter(
                            (col) => col.merchantId === merchant
                        );
                        if (Filterlocation.length > 0) {
                            Filterlocation[0].isSelected = true;
                            Filterlocation[0].alias = utils.Validate(Filterlocation[0].alias) ? Filterlocation[0].alias : Filterlocation[0].urlAddress;
                            location.current.map((d, i) => {
                                if (d.merchantId === merchant) {
                                    location.current[i] = Filterlocation[0];
                                }
                            })
                        }
                    }

                }
            });
            if (locationPlan.current.length > 0) {
                if (filterChild.length > 0) {
                    locationPlan.current.map((d, j) => {
                        if (d.fromPlan <= filterChild.length && d.toPlan >= filterChild.length) {
                            setPlanAmount(d.charges);
                        }
                    });
                }
                else {
                    locationPlan.current.map((d, j) => {
                        if (d.fromPlan <= 1 && d.toPlan >= 1) {
                            setPlanAmount(d.charges);
                        }
                    });
                }
            }
            selectedLocation.current = filterChild;
        }
        else {
            if (locationPlan.current.length > 0) {
                locationPlan.current.map((d, j) => {
                    if (d.fromPlan <= 1 && d.toPlan >= 1) {
                        setPlanAmount(d.charges);
                    }
                });
            }
            selectedLocation.current = [];
        }
        UpdateLockState();

        stateName = "";
        stateIndex = 0;
        setIsRefresh(!isRefresh);
        let LocationList = location.current.filter(
            (col) => col.isSelected === true
        );
        setLocationCount(LocationList.length);
    }

    //save multilocation based on selections.
    let PopupType = 1;
    const SaveLocation = async (Mode) => {

        compareString.current = selectedLocation.current.toString();
        if (location.current && location.current.length > 0) {
            aliasTypeCompare.current = location.current[0].alias;
        }

        if (props.designer)
            props.designer.onBeforeClosePanelAlert = "";

        const access_token = await useGenerateToken(dispatch);
        if (!IsModifyAllowed) {
            utils.ShowAlert("Alert", "You do not have access to save multilocations.", "OpenDialog");
        }
        else {
            PopupType = Mode;
            if (utils.Validate(access_token)) {
                let SelectedBusiness = location.current.filter(
                    (col) => col.isSelected === true
                );
                var selectedataLocationlist = [];
                if (SelectedBusiness.length > 0) {
                    SelectedBusiness.map((d, i) => {
                        var param = {};
                        param.strBusinessID = d.merchantId;
                        param.type = utils.Validate(d.urlType) ? d.urlType : 1;
                        param.URL = param.type == 1 ? d.urlAddress : d.urlName;
                        param.isPromoBusiness = d.isPromoBusiness;
                        selectedataLocationlist.push(param);
                    });
                }
                if (Mode == 2) {
                    props.onLoading(true);
                }
                else {
                    setSaveStencil(true);
                }
                await AsyncAjaxPost(
                    VagaroAPIURL.SaveMultilocation,
                    selectedataLocationlist,
                    access_token,
                    SaveLocation_Success,
                    SaveLocation_Fail,
                    BusinessID,
                    UserID
                );
            }
            else {
                utils.ShowAlert("Alert!", "Something went wrong. Please refresh your browser and try again!", "OpenDialog", true);
            }
        }
    }

    //save success methods multilocation based on selections.
    const SaveLocation_Success = (data) => {
        try {
            if (
                data != null &&
                data.data != null &&
                data.data.responseCode == ResponseCode.Success
            ) {
                if (data != null && data.data != null && data.data.data != null) {
                    dispatch(UpdateLocationCount(data.data.data));

                    if (props.designer)
                        props.designer.panelMenuLocked = false;
                    if (PopupType == 1) {
                        if (!props.onCancel) {
                            utils.ShowAlert("Alert!", "Multi-location has been saved successfully.", "OpenDialog", true);
                            setSaveStencil(false);
                        }
                        else {
                            Toast("Multi-location has been saved successfully.");
                        }
                        if (props.onCancel) {
                            props.onCancel();
                        }
                    }
                    else {
                        props.ActivateDeactiveWebsiteBuilder();
                    }
                }
            }
        } catch (error) {
            SaveLocation_Fail();
        }
    }

    //save fail methods multilocation based on selections.
    const SaveLocation_Fail = () => {
        setLoadStencil(false);
        utils.ShowAlert("Message", "Please reload this page and try again.", "OpenDialog");
    }

    const setApplyGrid = (selctedValue) => {
        if (location.current.length > 0) {
            location.current.map((d, i) => {
                d.urlType = selctedValue;
                d.alias = selctedValue == 1 ? d.urlAddress : d.urlName;
                d.isDefaultSelected = false;
            });
            setIsRefresh(!isRefresh);
        }
        UpdateLockState();
    }

    //press edit button and open popup page.
    const ChangeName = async (data) => {
        const access_token = await useGenerateToken(dispatch);
        if (!IsModifyAllowed) {
            utils.ShowAlert("Alert", "You do not have access to edit location.", "OpenDialog");
        }
        else {
            return ReactDom.render(
                <ChangeNickName
                    businessID={BusinessID}
                    userID={UserID}
                    mapBusinessID={data.merchantId}
                    vagaroURL={VagaroURL}
                    nickName={data.nickName}
                    mappingType={data.urlType}
                    access_token={access_token}
                    domainName={data.domain}
                    urlAddress={data.urlAddress}
                    urlName={data.urlName}
                    setApplyGrid={setApplyGrid}
                />,
                document.getElementById("OpenDialog"))
        }
    }

    //close popup.
    const CancelPopup = () => {
        unmountComponentAtNode(document.getElementById("OpenDialog"));
    };

    let link = "https://www.vagaro.com/pro/contact-sales-team";
    if (CountryID == 1) {
        link = "https://www.vagaro.com/pro/contact-sales-team";
    }
    else if (CountryID == 2) {
        link = "https://www.vagaro.com/en-gb/pro/contact-sales-team";
    }
    else if (CountryID == 3) {
        link = "https://www.vagaro.com/en-ca/pro/contact-sales-team";
    }
    else if (CountryID == 4) {
        link = "https://www.vagaro.com/en-au/pro/contact-sales-team";
    }

    //open charges popup.
    const OpenCharges = () => {
        return ReactDom.render(
            <VGPopUp
                show={true}
                onHide={CancelPopup}
                title="Tiered Pricing"
                body={
                    <Fragment>
                        <div className="alertContent">
                            <p>The pricing is calculated based on how many locations are included in your MySite. </p>
                        </div>
                        <div className="multilocation-table">
                            <table className="multi-table">
                                <thead>
                                    <tr>
                                        <th className="row-33-percentage">Tier</th>
                                        <th className="row-33-percentage">Number of Locations</th>
                                        <th className="row-33-percentage">Price ({CurrencySymbol}/mo)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <Fragment>
                                        {locationPlan.current.map((data, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td className="row-33-percentage">Tier {index + 1}</td>
                                                    <td className="row-33-percentage">{data.fromPlan == data.toPlan ? data.fromPlan : (data.fromPlan + (utils.Validate(data.toPlan) && data.toPlan < 32767 ? ("-" + data.toPlan) : "+"))}</td>
                                                    <td className="row-33-percentage">{data.isContactSales ? <a href={link} target="_blank" style={{ textDecoration: "none" }}> Contact Sales </a> : CurrencySymbol + data.charges} </td>
                                                </tr>
                                            )
                                        })}
                                    </Fragment>
                                </tbody>
                            </table>
                        </div>
                    </Fragment>
                }
                footer={
                    <button
                        className="w-button w-button-secondary"
                        type="button"
                        onClick={CancelPopup}
                    >
                        Close
                    </button>
                }
                isShowFooter={true}
            />,
            document.getElementById("OpenDialog")
        );
    };

    //state wise toggle.
    const toggleExpanded = (e) => {
        var stateIndex = e.target.getAttribute('data-tr');
        if (stateIndex != null) {
            if ($('button[data-btn=' + stateIndex + ']').attr('class') == "multi-collaps-btn") {
                $('tr[data-child=' + stateIndex + ']').hide();
                $('button[data-btn=' + stateIndex + ']').attr('class', 'multi-collaps-btn expanded');
            }
            else {
                $('tr[data-child=' + stateIndex + ']').show();
                $('button[data-btn=' + stateIndex + ']').attr('class', 'multi-collaps-btn');
            }
        }
    };

    //selection location methods in publish popup
    const selectedLocationMethod = (data) => {
        if (location.current.length > 0) {
            location.current.map((d, i) => {
                if (d.isDefault == false) {
                    d.isSelected = false;
                }
            });
        }
        data.map((merchant, j) => {
            if (merchant.trim() != "" && merchant.trim() != "-1") {
                if (location.current.length > 0) {
                    var Filterlocation = location.current.filter(
                        (col) => col.merchantId === merchant
                    );
                    if (Filterlocation.length > 0) {
                        Filterlocation[0].isSelected = true;
                        Filterlocation[0].alias = Filterlocation[0].urlAddress;
                        location.current.map((d, i) => {
                            if (d.merchantId === merchant) {
                                location.current[i] = Filterlocation[0];
                            }
                        })
                    }
                }
            }
        })
    }


    const style = {
        maxHeight: "1em",
        overflow: "hidden",
        opacity: 1
    }

    var stateName = "";
    var stateIndex = 0;

    let LocationList = location.current.filter(
        (col) => col.isSelected === true
    );

    const StencilLoader = (data) => {
        var arrayHtml = [];
        for (var i = 1; i <= data.row; i++) {
            arrayHtml.push(i);
        }
        return (
            arrayHtml.map((data, index) => {
                return (
                    <Fragment>
                        <tr>
                            <td colSpan={4}>
                                <div className="stenciled  flex-column gap-small w-full">
                                    <div className='w-full stencil-item' style={style}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                </div>
                            </td>

                        </tr>
                        <tr>
                            <td>
                                <div className="stenciled  flex-column gap-small w-full">
                                    <div className='w-full stencil-item' style={style}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                </div>
                            </td>
                            <td colSpan={2}>
                                <div className="stenciled  flex-column gap-small w-full">
                                    <div className='w-full stencil-item' style={style}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                </div>
                            </td>
                            <td>
                                <div className="stenciled  flex-column gap-small w-full">
                                    <div className='w-full stencil-item' style={style}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                    <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                </div>
                            </td>
                        </tr>
                    </Fragment>
                )
            })
        )
    }

    const CheckMySitePublish = (siteurl, vagaroURL, alias) => {
        if (IsNewCustomWebSite) {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = siteurl + "/" + vagaroURL + "/" + alias;
            a.click();
        }
        else {
            utils.ShowAlert("Message", "Site is not published yet.", "OpenDialog");
        }
    }


    const CheckDomainPublish = (siteurl, alias) => {
        if (IsNewCustomWebSite) {
            let a = document.createElement('a');
            a.target = '_blank';
            a.href = "https://" + siteurl + "/" + alias;
            a.click();
        }
        else {
            utils.ShowAlert("Message", "Website builder is not published.", "OpenDialog");
        }
    }



    return (
        <Fragment>
            <Fragment>
                {
                    props.Mode == 1 &&
                    <Fragment>
                        <div className={
                            props.hidePannel ? "" :
                                ReactBusinessId <= 0
                                    ? "all-content-container no-access-main-content-wrapper"
                                    : "all-content-container main-content-wrapper"
                        }
                        >
                            {/* import left panel */}
                            {!props.hidePannel &&
                                <Leftpanel
                                    activateTab={"GeneralSetting"}
                                    activatePage={"Multilocation"}
                                />}
                            {(() => {
                                if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                                    return (
                                        <Fragment>
                                            <NoRights onCancel={props.onCancel} />
                                        </Fragment>
                                    );
                                } else {
                                    return (
                                        <Fragment>
                                            <div className="page-root">
                                                {(() => {
                                                    if (ReactBusinessId === 0 || typeof ReactBusinessId === 'undefined') {
                                                        return <NoRights onCancel={props.onCancel} />;
                                                    } else {
                                                        return (
                                                            ReactBusinessId > 0 &&
                                                            <Fragment>
                                                                <div className="page-content container multilocation-sectoin">
                                                                    <Form className="form-content">
                                                                        <Form.Group className={`form-row`}>
                                                                            <div className="multilocation-banner">
                                                                                <div className="multi-bnr-decs">
                                                                                    <h2>Multi-Location</h2>
                                                                                    <p>Design your website once for one location and then enable this feature to automatically duplicate pages for selected locations of your business within minutes.</p>
                                                                                </div>
                                                                                <div className="multi-images">
                                                                                    <img src="https://1a96a36bae7c8550901a-274b8a70320bb26e7a1e0ea7836ee429.ssl.cf2.rackcdn.com/PublicImages/Images/multilocation-banner-img.png" alt=""></img>
                                                                                </div>
                                                                            </div>
                                                                        </Form.Group>
                                                                        {loadStencil ? <Fragment>
                                                                            <Form.Group className={`form-row`}>
                                                                                <div className="multi-title">Active Locations</div>
                                                                                <div className="multi-col-row">
                                                                                    <div className="multi-select-control">
                                                                                        <div className="stenciled  flex-column gap-small w-full">
                                                                                            <div className='w-full stencil-item' style={style}>&nbsp;</div>
                                                                                            <div className='w-full stencil-item' style={{ ...style }}>&nbsp;</div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                                <div className="multilocation-table">
                                                                                    <table className="multi-table">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Business Name</th>
                                                                                                <th colSpan={2}>URL</th>
                                                                                                <th>Address</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            <StencilLoader row={2} />
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </Form.Group>
                                                                        </Fragment> :
                                                                            <Form.Group className={`form-row`}>
                                                                                <div className="multi-title">Active Locations</div>
                                                                                <div className="multi-col-row">
                                                                                    <div className="multi-select-control">
                                                                                        <Form.Label>Select Locations:</Form.Label>
                                                                                        <MultiSelectBusiness
                                                                                            className="vg-custom-select employee-vg-select"
                                                                                            classNamePrefix="vg-select"
                                                                                            aria-label="Default select example"
                                                                                            options={select2Location}
                                                                                            onChange={(id) => {
                                                                                                MultiLocationSelect(id);
                                                                                            }}
                                                                                            defaultValue={selectedLocation.current}
                                                                                            placeholder={"Select Business Location"}
                                                                                            ControlID="ddllocation"
                                                                                            searchInputPlaceholder="Search"
                                                                                        />
                                                                                    </div>
                                                                                    {locationPlan.current.length > 0 &&
                                                                                        <div className="multi-col-month">
                                                                                            <a style={{ textDecoration: "none", cursor: "pointer" }} className="calculate-link-new" onClick={() => OpenCharges()}>Monthly cost will be {CurrencySymbol}{planAmount}/mo.</a>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                                <div className="multilocation-table">
                                                                                    <table className="multi-table">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th>Business Name</th>
                                                                                                <th colSpan={2}>URL</th>
                                                                                                <th>Address</th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            {saveStencil ?
                                                                                                <StencilLoader row={LocationList.length > 0 ? LocationList.length : 2}></StencilLoader>
                                                                                                :
                                                                                                LocationList.length > 0 ? LocationList.map((data, index) => {
                                                                                                    var isShowCategory = false;

                                                                                                    if (isPromoCodeBusiness.current == true) {
                                                                                                        if (index == 0) {
                                                                                                            stateName = data.stateName;
                                                                                                            isShowCategory = true;
                                                                                                            stateIndex = index;
                                                                                                        }
                                                                                                        else if (data.stateName != LocationList[index - 1].stateName) {
                                                                                                            stateName = data.stateName;
                                                                                                            isShowCategory = true;
                                                                                                            stateIndex = index;
                                                                                                        }
                                                                                                    }
                                                                                                    else {
                                                                                                        if (index == 0 && utils.Validate(data.groupName)) {
                                                                                                            stateName = data.groupName;
                                                                                                            isShowCategory = true;
                                                                                                            stateIndex = index;
                                                                                                        }
                                                                                                        else if (index > 0 && data.groupName != LocationList[index - 1].groupName) {
                                                                                                            stateName = data.groupName;
                                                                                                            isShowCategory = true;
                                                                                                            stateIndex = index;
                                                                                                        }
                                                                                                    }
                                                                                                    return (
                                                                                                        <Fragment key={index}>
                                                                                                            {isShowCategory &&
                                                                                                                <tr onClick={(e) => toggleExpanded(e)}>
                                                                                                                    <td data-tr={stateIndex} colSpan={4} >
                                                                                                                        <button data-btn={stateIndex} type="button" className='multi-collaps-btn'>
                                                                                                                            <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                                                                <path d="M7 8.0625C6.73633 8.0625 6.50195 7.97461 6.32617 7.79883L0.701172 2.17383C0.320312 1.82227 0.320312 1.20703 0.701172 0.855469C1.05273 0.474609 1.66797 0.474609 2.01953 0.855469L7 5.80664L11.9512 0.855469C12.3027 0.474609 12.918 0.474609 13.2695 0.855469C13.6504 1.20703 13.6504 1.82227 13.2695 2.17383L7.64453 7.79883C7.46875 7.97461 7.23438 8.0625 7 8.0625Z" fill="#333333" />
                                                                                                                            </svg>
                                                                                                                        </button>
                                                                                                                        {stateName}
                                                                                                                    </td>
                                                                                                                </tr>
                                                                                                            }
                                                                                                            <Fragment>
                                                                                                                <tr className="expanded-row" data-child={stateIndex}>
                                                                                                                    <td className="row-30-percentage">
                                                                                                                        <div className="business-details">
                                                                                                                            <div className="busi-profile"><img src={data.cdn} width={"60px"} height={"40px"} ></img></div>
                                                                                                                            <div className="busi-decs">{data.businessName + (utils.Validate(data.nickName) ? ' (' + data.nickName + ')' : "")}</div>
                                                                                                                        </div>
                                                                                                                    </td>
                                                                                                                    <td className="row-20-percentage">
                                                                                                                        {
                                                                                                                            IsNewCustomWebSite ?
                                                                                                                                utils.Validate(data.domain) ?
                                                                                                                                    (data.isDefaultSelected ? <a style={{ cursor: "pointer" }} target="_blank" onClick={() => CheckDomainPublish(data.domain, data.alias)} title="">{data.domain + '/' + data.alias}</a> : <span>{data.domain + '/' + data.alias} <span className="info">ⓘ <p>This business is not clickable, first save it and click on URL.</p></span></span>)
                                                                                                                                    :
                                                                                                                                    (data.isDefaultSelected ? <a onClick={() => CheckMySitePublish(utils.MySiteName(), VagaroURL, data.alias)} style={{ cursor: "pointer" }} target="_blank" title="">{utils.MySiteName().replace("https://", "") + '/' + VagaroURL + '/' + data.alias}</a> : <span>{utils.MySiteName().replace("https://", "") + '/' + VagaroURL + '/' + data.alias} <span className="info">ⓘ <p>This business is not clickable, first save it and click on URL.</p></span></span>)

                                                                                                                                :
                                                                                                                                (utils.Validate(data.domain) ? <span>{data.domain + '/' + data.alias} <span className="info">ⓘ <p>Website builder is deactivated, First activate website builder and click it.</p></span></span> :
                                                                                                                                    <span>{utils.MySiteName().replace("https://", "") + '/' + VagaroURL + '/' + data.alias} <span className="info">ⓘ <p>Website builder is deactivated, First activate website builder and click it.</p></span></span>)
                                                                                                                        }
                                                                                                                    </td>
                                                                                                                    <td className="row-10-percentage" >
                                                                                                                        <a style={{ cursor: "pointer" }} class="tab-link" onClick={() => ChangeName(data)}>
                                                                                                                            <svg width="15px" height="15px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 18" fill="currentColor">
                                                                                                                                <path d="M1.7915 12.2812C1.9165 11.8438 2.1665 11.4375 2.479 11.125L11.979 1.625C12.7603 0.84375 14.0415 0.84375 14.8228 1.625L16.0415 2.84375C16.1353 2.9375 16.229 3.0625 16.2915 3.15625C16.8228 3.9375 16.729 5 16.0415 5.6875L6.5415 15.1875C6.51025 15.2188 6.44775 15.25 6.4165 15.3125C6.104 15.5625 5.76025 15.75 5.38525 15.875L1.604 16.9688C1.354 17.0625 1.07275 17 0.885254 16.7812C0.666504 16.5938 0.604004 16.3125 0.666504 16.0625L1.7915 12.2812ZM2.51025 15.1562L4.94775 14.4375C5.01025 14.4062 5.104 14.375 5.1665 14.3438L4.0415 14.125C3.7915 14.0625 3.57275 13.875 3.5415 13.625L3.32275 12.5C3.2915 12.5625 3.26025 12.6562 3.229 12.7188L2.51025 15.1562ZM6.2915 13.3125L12.6353 6.96875L10.6665 5.03125L4.354 11.375L4.6665 12.9688L6.2915 13.3125Z">
                                                                                                                                </path>
                                                                                                                            </svg>
                                                                                                                        </a>
                                                                                                                    </td>
                                                                                                                    <td className="row-20-percentage">{data.street + ", " + data.city + ", " + data.stateCode + " " + data.zip}</td>
                                                                                                                </tr>
                                                                                                            </Fragment>
                                                                                                        </Fragment>
                                                                                                    )
                                                                                                })
                                                                                                    : <Fragment>
                                                                                                        {loadStencil == false &&
                                                                                                            <tr>
                                                                                                                <td colSpan={4}>No Location Found.</td>
                                                                                                            </tr>
                                                                                                        }
                                                                                                    </Fragment>
                                                                                            }
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </Form.Group>
                                                                        }
                                                                    </Form>
                                                                    {loadStencil == false &&
                                                                        <div className="page-title title-with-actions">
                                                                            <div className="inline-actions-btns">
                                                                                {props.onCancel &&
                                                                                    <button
                                                                                        className="w-button w-button-secondary"
                                                                                        onClick={() => {
                                                                                            compareString.current = selectedLocation.current.toString();
                                                                                            props.onCancel();
                                                                                        }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>

                                                                                }
                                                                                <button className="w-button w-button-primary close-on-click" onClick={() => SaveLocation(1)}>
                                                                                    Save
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </Fragment>
                                                        );
                                                    }
                                                })()}
                                            </div>
                                        </Fragment >
                                    );
                                }
                            })()}
                        </div>
                    </Fragment>
                }
            </Fragment>
            <Fragment>
                {
                    props.Mode == 2 && defaultBusinessID.current != "" && locationPlan.current.length > 0 && IsModifyAllowed &&
                    <Fragment>
                        <SaveMultilocation
                            allLocation_data={select2Location}
                            selectedLocation_data={selectedLocation.current}
                            BusinessID={[defaultBusinessID.current]}
                            CurrencySymbol={CurrencySymbol}
                            PlanAmount={planAmount}
                            locationPlan={locationPlan.current}
                            saveLocation={SaveLocation}
                            selectedLocationMethod={selectedLocationMethod}
                        />
                    </Fragment>
                }
            </Fragment>
        </Fragment>
    );

}


export default Multilocation;
